export default "__VITE_ASSET__94e1faf2__"